import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "data-table"
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading || _vm._pageLoading,
      expression: "loading || _pageLoading"
    }],
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "mini",
      data: _vm.dataList,
      border: "",
      "empty-text": _vm.initSearch ? "请选择或输入筛选条件搜索对应数据" : "暂无数据",
      stripe: "",
      "max-height": _vm.maxHeight
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      fixed: "left",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ConfirmCode",
      fixed: "left",
      label: "函证编码",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref) {
        var column = _ref.column,
          $index = _ref.$index;
        return [_c("span", [_vm._v("函证编码")]), _c("div", {
          staticClass: "sort-wrap"
        }, [_c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "搜索"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02ConfirmCode", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.stopPropagation();
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }), _c("div", {
          staticClass: "sort",
          on: {
            click: function click($event) {
              return _vm.sortChange("c02ConfirmCode");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-caret-top",
          class: {
            highlight: _vm.sortType === "desc"
          }
        }), _c("i", {
          staticClass: "el-icon-caret-bottom",
          class: {
            highlight: _vm.sortType === "asc"
          }
        })])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c03CusName",
      fixed: "left",
      label: "函证对象名称",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref2) {
        var column = _ref2.column,
          $index = _ref2.$index;
        return [_c("span", [_vm._v("函证对象名称")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "函证对象名称",
            disabled: _vm.searchLoading
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c03ConfirmObj.c03CusName", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.stopPropagation();
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }])
  }), _vm.admin ? _c("el-table-column", {
    attrs: {
      label: "作业客户名",
      fixed: "left",
      prop: "c01CusName",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref3) {
        var column = _ref3.column,
          $index = _ref3.$index;
        return [_c("span", [_vm._v("作业客户名")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "搜索"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c01task.c01CusName", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c01task ? scope.row.c01task.c01CusName : ""))])];
      }
    }], null, false, 3718383424)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "被审单位",
      fixed: "left",
      prop: "c01CusName",
      width: "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref4) {
        var column = _ref4.column,
          $index = _ref4.$index;
        return [_c("span", [_vm._v("被审单位")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "搜索"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02AuditCompany", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c02AuditCompany))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证类型",
      fixed: _vm.admin ? false : "left",
      prop: "c02Type",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref5) {
        var column = _ref5.column,
          $index = _ref5.$index;
        return [_c("span", [_vm._v("函证类型")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02Type", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, _vm._l(_vm.correspondenceType, function (item) {
          return _c("el-option", {
            key: item,
            attrs: {
              label: item,
              value: item
            }
          });
        }), 1)];
      }
    }])
  }), !_vm.admin ? _c("el-table-column", {
    attrs: {
      width: "80",
      label: "样本类型",
      prop: "c02SampleType"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref6) {
        var column = _ref6.column,
          $index = _ref6.$index;
        return [_c("span", [_vm._v("样本类型")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02SampleType", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, _vm._l(_vm.sampleTypes, function (item) {
          return _c("el-option", {
            key: item.n04Id,
            attrs: {
              label: item.n04Value,
              value: item.n04Value
            }
          });
        }), 1)];
      }
    }], null, false, 887500854)
  }) : _vm._e(), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "期数/截止日期",
      prop: "address",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref7) {
        var column = _ref7.column,
          $index = _ref7.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("期数")]), _c("div", [_vm._v("截止日期")])]);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c02PeriorType) + "/" + _vm._s(_vm._f("date")(scope.row.c02Perior, "yyyy-MM-dd")))])];
      }
    }], null, false, 2786336092)
  }) : _c("el-table-column", {
    attrs: {
      label: "截止日期",
      prop: "c02Perior",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref8) {
        var column = _ref8.column,
          $index = _ref8.$index;
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "勾选精确搜索日期，如：2023-05-10；取消勾选搜索当月，如选择2023-05-10，会匹配2023-05当月所有数据",
            placement: "top"
          }
        }, [_c("span", [_vm._v(_vm._s(column.label)), _c("el-checkbox", {
          attrs: {
            size: "mini"
          },
          model: {
            value: _vm.includeDate,
            callback: function callback($$v) {
              _vm.includeDate = $$v;
            },
            expression: "includeDate"
          }
        })], 1)]), _c("div", {
          staticClass: "sort-wrap"
        }, [_c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            type: "date",
            placeholder: "截止日期",
            clearable: "",
            size: "mini",
            "value-format": "yyyy-MM-dd"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02Perior", value, "month");
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }), _c("div", {
          staticClass: "sort",
          on: {
            click: function click($event) {
              return _vm.sortChange("c02Perior");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-caret-top",
          class: {
            highlight: _vm.sortType === "desc"
          }
        }), _c("i", {
          staticClass: "el-icon-caret-bottom",
          class: {
            highlight: _vm.sortType === "asc"
          }
        })])], 1)];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(_vm._f("date")(scope.row.c02Perior, "yyyy-MM-dd")))])];
      }
    }])
  }), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "预览",
      prop: "tmp",
      width: "45"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.c02Confirm ? _c("popover-pre-doc", {
          key: "".concat(scope.row.c02Id, "-").concat(scope.$index),
          attrs: {
            "task-id": _vm.id,
            "loading-list": _vm.loadingDocList,
            "confirm-id": scope.row.c02Id,
            "sys-params": _vm.getSysParams(scope.row),
            content: scope.row.c02Confirm,
            history: _vm.history,
            "in-table": true,
            html: scope.row._content
          },
          on: {
            data: function data(_data) {
              return _vm.setContent(scope.row, _data, scope.$index);
            },
            loadingList: _vm.setLoadingItem
          }
        }) : _vm._e()];
      }
    }], null, false, 890314239)
  }) : _vm._e(), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "发函前核验",
      prop: "c02CheckProcess",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref9) {
        var column = _ref9.column,
          $index = _ref9.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("发函前")]), _c("div", [_vm._v("核验")])]);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return scope.row.c02CheckProcess ? [_c("el-popover", {
          attrs: {
            placement: "top-start",
            width: "250",
            trigger: "hover"
          }
        }, [_c("div", [_vm._v(" " + _vm._s(scope.row.c02CheckProcess) + " ")]), _c("el-icon", {
          staticClass: "el-icon-info",
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        })], 1)] : undefined;
      }
    }], null, true)
  }) : _vm._e(), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "创建人/日期",
      width: "125",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref0) {
        var column = _ref0.column,
          $index = _ref0.$index;
        return [_c("span", [_vm._v("创建人/日期")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "搜索创建人"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02CreateName", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.c02CreateName))]), _c("div", [_vm._v(_vm._s(_vm._f("date")(scope.row.c02CreateDate, "yyyy-MM-dd")))])];
      }
    }], null, false, 364345923)
  }) : _c("el-table-column", {
    attrs: {
      label: "创建日期",
      width: "90",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref1) {
        var column = _ref1.column,
          $index = _ref1.$index;
        return [_c("span", [_vm._v(_vm._s(column.label))]), _c("div", {
          staticClass: "sort-wrap"
        }, [_c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            type: "date",
            placeholder: "创建日期",
            clearable: "",
            size: "mini",
            "value-format": "yyyy-MM-dd"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02CreateDate", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }), _c("div", {
          staticClass: "sort",
          on: {
            click: function click($event) {
              return _vm.sortChange("c02CreateDate");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-caret-top",
          class: {
            highlight: _vm.sortType === "desc"
          }
        }), _c("i", {
          staticClass: "el-icon-caret-bottom",
          class: {
            highlight: _vm.sortType === "asc"
          }
        })])], 1)];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(_vm._f("date")(scope.row.c02CreateDate, "yyyy-MM-dd")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函方式",
      prop: "c02SendType",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref10) {
        var column = _ref10.column,
          $index = _ref10.$index;
        return [_c("span", [_vm._v("发函方式")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02SendType", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, _vm._l(_vm.correspondenceTypes, function (item) {
          return _c("el-option", {
            key: item.n04Id,
            attrs: {
              label: item.n04Value,
              value: item.n04Value
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函日期",
      width: "90",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref11) {
        var column = _ref11.column,
          $index = _ref11.$index;
        return [_c("span", [_vm._v(_vm._s(column.label))]), _c("div", {
          staticClass: "sort-wrap"
        }, [_c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            type: "date",
            placeholder: "发函日期",
            clearable: "",
            size: "mini",
            "value-format": "yyyy-MM-dd"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02SendDate", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }), _c("div", {
          staticClass: "sort",
          on: {
            click: function click($event) {
              return _vm.sortChange("c02SendDate");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-caret-top",
          class: {
            highlight: _vm.sortType === "desc"
          }
        }), _c("i", {
          staticClass: "el-icon-caret-bottom",
          class: {
            highlight: _vm.sortType === "asc"
          }
        })])], 1)];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(_vm._f("date")(scope.row.c02SendDate, "yyyy-MM-dd")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函快递单号",
      width: "100",
      prop: "c02BackNumber"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref12) {
        var column = _ref12.column,
          $index = _ref12.$index;
        return [_c("span", [_vm._v("发函快递单号")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "快递单号"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02SendNumber", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.c02SendNumber))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否转寄",
      width: "100",
      prop: "c02SuspectedRisks"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref13) {
        var column = _ref13.column,
          $index = _ref13.$index;
        return [_c("div", [_vm._v("是否转寄")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "关键字搜索"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02SuspectedRisks", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函次数",
      width: "70",
      prop: "c02SendNUM"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref14) {
        var column = _ref14.column,
          $index = _ref14.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("发函次数")])]);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [scope.row.c02SendFrequency ? _c("div", [_vm._v(" 已发" + _vm._s(scope.row.c02SendFrequency) + "次 ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函方式",
      width: "80",
      prop: "c02BackType"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref15) {
        var column = _ref15.column,
          $index = _ref15.$index;
        return [_c("span", [_vm._v("回函方式")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackType", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, _vm._l(_vm.reTypes, function (item) {
          return _c("el-option", {
            key: item,
            attrs: {
              label: item,
              value: item
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函日期",
      width: "120",
      prop: "c02BackConfirmDate"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref16) {
        var column = _ref16.column,
          $index = _ref16.$index;
        return [_c("div", [_vm._v(_vm._s(column.label))]), _c("div", {
          staticClass: "sort-wrap"
        }, [_c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            clearable: "",
            size: "mini",
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "yyyy-MM-dd"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackConfirmDate", value, "between");
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }), _c("div", {
          staticClass: "sort",
          on: {
            click: function click($event) {
              return _vm.sortChange("c02BackConfirmDate");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-caret-top",
          class: {
            highlight: _vm.sortType === "desc"
          }
        }), _c("i", {
          staticClass: "el-icon-caret-bottom",
          class: {
            highlight: _vm.sortType === "asc"
          }
        })])], 1)];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(_vm._f("date")(scope.row.c02BackConfirmDate, "yyyy-MM-dd")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函快递单号",
      width: "100",
      prop: "c02BackNumber"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref17) {
        var column = _ref17.column,
          $index = _ref17.$index;
        return [_c("span", [_vm._v("回函快递单号")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "快递单号"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02BackNumber", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.c02BackNumber))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函附件",
      width: "55",
      prop: "c02BackConfirmFile"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref18) {
        var column = _ref18.column,
          $index = _ref18.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("附件")])]);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [scope.row.c02BackConfirmFile ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            width: "200",
            trigger: "hover"
          }
        }, [_c("div", {
          staticClass: "view-wrap"
        }, [_c("p", {
          staticClass: "view-detail",
          on: {
            click: function click($event) {
              return _vm.getFileUrl2(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.c02BackConfirmFile))]), _c("p", {
          staticClass: "view-detail download",
          on: {
            click: function click($event) {
              return _vm.getFileUrl2(scope.row, true);
            }
          }
        }, [_vm._v("下载")])]), _c("span", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("cpsc-icon", {
          attrs: {
            hover: true,
            name: "el-icon-view"
          }
        })], 1)]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证结论",
      width: "70",
      prop: "c02BackConfirmConclusion"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref19) {
        var column = _ref19.column,
          $index = _ref19.$index;
        return [_c("span", [_vm._v("函证结论")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackConfirmConclusion", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "相符",
            value: "相符"
          }
        }), _c("el-option", {
          attrs: {
            label: "不符",
            value: "不符"
          }
        })], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函初判",
      width: "70",
      prop: "c02BackConfirmValid"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref20) {
        var column = _ref20.column,
          $index = _ref20.$index;
        return [_c("span", [_vm._v("回函初判")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackConfirmValid", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "正常",
            value: "正常"
          }
        }), _c("el-option", {
          attrs: {
            label: "异常",
            value: "异常"
          }
        }), _c("el-option", {
          attrs: {
            label: "未验",
            value: "未验"
          }
        })], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "地址初判",
      width: "70",
      prop: "c02BackAddressStatus"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref21) {
        var column = _ref21.column,
          $index = _ref21.$index;
        return [_c("span", [_vm._v("地址初判")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackAddressStatus", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "正常",
            value: "正常"
          }
        }), _c("el-option", {
          attrs: {
            label: "异常",
            value: "异常"
          }
        })], 1)];
      }
    }])
  }), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "地址确认",
      width: "70",
      prop: "c02BackAddressReStatus"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref22) {
        var column = _ref22.column,
          $index = _ref22.$index;
        return [_c("span", [_vm._v("地址确认")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackAddressReStatus", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "正常",
            value: "正常"
          }
        }), _c("el-option", {
          attrs: {
            label: "异常",
            value: "异常"
          }
        })], 1)];
      }
    }], null, false, 652947989)
  }) : _vm._e(), !_vm.admin ? _c("el-table-column", {
    attrs: {
      label: "函证确认",
      width: "70",
      prop: "c02BackConfirmReConclusion"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref23) {
        var column = _ref23.column,
          $index = _ref23.$index;
        return [_c("span", [_vm._v("函证确认")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackConfirmReConclusion", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "有效",
            value: "有效"
          }
        }), _c("el-option", {
          attrs: {
            label: "无效",
            value: "无效"
          }
        })], 1)];
      }
    }], null, false, 1692676458)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "领取状态",
      width: "70",
      prop: "c02GetStatus"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref24) {
        var column = _ref24.column,
          $index = _ref24.$index;
        return [_c("span", [_vm._v("领取状态")]), _c("el-select", {
          staticClass: "table-header-select",
          attrs: {
            size: "mini",
            filterable: "",
            clearable: "",
            "allow-create": "",
            placeholder: "请选择"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02GetStatus", value);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        }, [_c("el-option", {
          attrs: {
            label: "未领取",
            value: "未领取"
          }
        }), _c("el-option", {
          attrs: {
            label: "已领取",
            value: "已领取"
          }
        }), _c("el-option", {
          attrs: {
            label: "不适用",
            value: "不适用"
          }
        })], 1)];
      }
    }])
  }), _vm.admin ? _c("el-table-column", {
    attrs: {
      label: "",
      width: "90",
      prop: "c02BackConfirmName"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref25) {
        var column = _ref25.column,
          $index = _ref25.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("回函操作人")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "回函操作人"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02BackConfirmName", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })], 1);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(" " + _vm._s(scope.row.c02BackConfirmName) + " ")])];
      }
    }], null, false, 500070094)
  }) : _vm._e(), _vm.admin ? _c("el-table-column", {
    attrs: {
      label: "",
      width: "100",
      prop: "c02BackConfirmOperateDate"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref26) {
        var column = _ref26.column,
          $index = _ref26.$index;
        return _c("div", {
          staticClass: "table-cell"
        }, [_c("div", [_vm._v("操作日期")]), _c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            clearable: "",
            size: "mini",
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "yyyy-MM-dd"
          },
          on: {
            change: function change(value) {
              return _vm.searchDate("c02BackConfirmOperateDate", value, "between");
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })], 1);
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c02BackConfirmOperateDate, "yyyy-MM-dd")) + " ")])];
      }
    }], null, false, 1497285443)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "函证状态",
      width: "100",
      prop: "c02Status",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref27) {
        var column = _ref27.column,
          $index = _ref27.$index;
        return [_c("div", [_vm._v("函证/币码状态")]), _c("el-input", {
          staticClass: "table-header-input",
          attrs: {
            size: "mini",
            placeholder: "函证状态"
          },
          on: {
            change: function change(value) {
              return _vm.bindModel("c02Status", value);
            }
          },
          nativeOn: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.onSearch.apply(null, arguments);
            }
          },
          model: {
            value: _vm.model[$index],
            callback: function callback($$v) {
              _vm.$set(_vm.model, $index, $$v);
            },
            expression: "model[$index]"
          }
        })];
      }
    }, {
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticClass: "table-item-status"
        }, [_c("span", [_vm._v(_vm._s(scope.row.c02Status))]), scope.row.c02GetStatus === "已领取" ? _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "".concat(scope.row.c02GetStaff, "/").concat(_vm.transformDate(scope.row.c02GetDate)),
            placement: "top"
          }
        }, [_c("span", [_vm._v("(" + _vm._s(scope.row.c02GetStatus) + ")"), _c("i", {
          staticClass: "el-icon-info"
        })])]) : _vm._e(), scope.row.c02SendType === "电子函证" && scope.row.c02Extended ? _c("div", [_vm._v(_vm._s(scope.row.c02Extended.currentProgress)), _c("el-popover", {
          attrs: {
            placement: "top",
            trigger: "hover",
            width: 480
          }
        }, [_c("div", {
          staticClass: "e-code-wrap"
        }, [_c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("币码ID")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.row.c02Extended.bimartId))])]), _c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("币码函证状态")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.row.c02Extended.currentProgress))])]), _c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("最后更新时间")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm._f("date")(scope.row.c02Extended.lastUpdatedAt)))])]), _c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("币码发函次数")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.row.c02Extended.repetitionCount))])]), _c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("最近一次发函结果")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.row.c02Extended.detailedInfo))])]), _c("div", {
          staticClass: "item"
        }, [_c("div", {
          staticClass: "label"
        }, [_vm._v("上一次发函结果")]), _c("div", {
          staticClass: "value"
        }, [_vm._v(_vm._s(scope.row.c02Extended.historyDetailedInfo))])])]), _c("span", {
          staticStyle: {
            cursor: "pointer"
          },
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("cpsc-icon", {
          attrs: {
            name: "el-icon-question"
          }
        })], 1)])], 1) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      prop: "address",
      fixed: "right",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.admin || _vm.canBeEdit(scope.row) ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-edit",
            title: "编辑"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }) : _vm._e(), scope.row.c02CreateStaff === _vm.userId && scope.row.c02Status === "草稿" && !scope.row.c02ConfirmCode && !_vm.history ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            loading: scope.row._loading,
            title: "删除",
            icon: "el-icon-delete"
          },
          on: {
            click: function click($event) {
              return _vm.remove(scope.row);
            }
          }
        }) : _vm._e(), scope.row.c02Status === "待审核" && (_vm.isManager || _vm.isCpscAdmin) && !_vm.history ? [_c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-s-check",
            title: "审核"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "approve", "审核");
            }
          }
        }), _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-refresh-right",
            title: "退审"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "reject", "退审");
            }
          }
        })] : _vm._e(), _vm.info.name === scope.row.c02CreateName && !_vm.history ? [scope.row.c02Status === "草稿" ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-document-checked",
            title: "置为待审"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "submit", "置为待审");
            }
          }
        }) : _vm._e(), scope.row.c02Status === "待审核" ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-document",
            title: "置为草稿"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "revoke", "置为草稿");
            }
          }
        }) : _vm._e(), scope.row.c02Status === "已审核" ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-s-promotion",
            title: "置为已发出"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "send", "置为已发出");
            }
          }
        }) : _vm._e(), scope.row.c02Status === "已发出" ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-takeaway-box",
            title: "置为已接收"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "receive", "置为已接收");
            }
          }
        }) : _vm._e(), scope.row.c02Status !== "草稿" && scope.row.c02Status !== "待审核" && scope.row.c02Status !== "作废" ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            loading: scope.row._loading,
            type: "text",
            size: "mini",
            icon: "el-icon-document-delete",
            title: "置为作废"
          },
          on: {
            click: function click($event) {
              return _vm.toTest(scope.row, "disable", "置为作废");
            }
          }
        }) : _vm._e()] : _vm._e(), (_vm.isCpscAdmin || _vm.admin || _vm.canBeEdit(scope.row)) && scope.row.c02SendType === "电子函证" && !_vm.history ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            loading: scope.row._loading,
            title: "获取币码详情",
            icon: "el-icon-help"
          },
          on: {
            click: function click($event) {
              return _vm.getEcodeDetail(scope.row);
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c("cpsc-auto-pagination", {
    attrs: {
      "current-page": _vm.currentPage,
      total: _vm.totalPages,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 20, 30, 40, 100, 200, 250, 300, 350, 400, 800, 1500]
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "size-change": _vm.handleSizeChange
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };